import React, { useState, useEffect } from 'react'
import { OneLevelMenu, OptionsList, OptionBox, OptionCheckBox } from 'uiComponents/menus/'
import { usePrevious } from 'reactUtils'
import { Settings } from 'lucide-react'
import { Navigation } from 'navigation'
import { withNavigation } from 'hocs'
import { match as RouteMatch } from 'react-router-dom'
import isEqual from 'lodash/isEqual'
import { useTranslation } from 'translations'

interface PricingTypeFilterProps {
    navigation: Navigation
    match: RouteMatch<any>
}

function PricingTypeFilter(props: PricingTypeFilterProps) {
    const { t } = useTranslation()
    const checkboxOptions = [
        { slug: 'rtp', name: t('products.viewSelector.pricingTypes.rtp') },
        { slug: 'static', name: t('products.viewSelector.pricingTypes.static') },
        { slug: 'upsell', name: t('products.viewSelector.pricingTypes.upsell') },
        { slug: 'nyop', name: t('products.viewSelector.pricingTypes.nyop') },
    ]
    const query = props.navigation.query()
    const selectedPricingTypes = query.pricingTypes ? decodeURIComponent(query.pricingTypes).split(',') : []
    const [selectedCheckboxes, setSelectedCheckboxes] = useState<string[]>(selectedPricingTypes)

    const prevPricingTypes = usePrevious(query.pricingTypes)
    useEffect(() => {
        if (!isEqual(query.pricingTypes, prevPricingTypes)) {
            setSelectedCheckboxes(selectedPricingTypes)
        }
    }, [query])

    const toggleCheckboxOptions = (slug: string) => {
        const updatedSelection =
            selectedCheckboxes.indexOf(slug) > -1
                ? selectedCheckboxes.filter((f) => f !== slug)
                : [...selectedCheckboxes, slug]
        setSelectedCheckboxes(updatedSelection)
        props.navigation.addQueryWithReplace({
            pricingTypes: encodeURIComponent(updatedSelection.join(',')),
        })
    }

    return (
        <div className="pricing-type-filter">
            <OneLevelMenu
                arrowHidden
                menuName={t('products.viewSelector.showByType')}
                selectedCount={selectedCheckboxes.length}
                closeMenu={false}
                disabledInfotipText=""
                icon={Settings}
            >
                <OptionsList style={{ padding: '.2em 0' }}>
                    {checkboxOptions.map((f) => (
                        <OptionBox key={f.slug} onClick={() => toggleCheckboxOptions(f.slug)}>
                            <OptionCheckBox
                                name={f.slug}
                                checked={selectedCheckboxes.indexOf(f.slug) > -1}
                                onChange={() => {}}
                            />
                            <span>{f.name}</span>
                        </OptionBox>
                    ))}
                </OptionsList>
            </OneLevelMenu>
        </div>
    )
}

export default withNavigation(PricingTypeFilter)
